// extracted by mini-css-extract-plugin
module.exports = {"bannerStyle":"GlobalBanner_bannerStyle__YDrQ_","stripLinkColor":"GlobalBanner_stripLinkColor__3C5Os"};